module.exports = __webpack_public_path__ + "img/typical-drill-active.0dac8ab2.svg";